var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.$route.params._ip ? _c('span', [_vm._v("IP 상세")]) : _c('span', [_vm._v("IP 생성")])]), _c('console-body', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("IP정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.whiteIp.name,
      callback: function callback($$v) {
        _vm.$set(_vm.whiteIp, "name", $$v);
      },
      expression: "whiteIp.name"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "IPv4 address",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "placeholder": "예) 127.0.0.1",
      "rules": _vm.rules,
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.whiteIp.ip,
      callback: function callback($$v) {
        _vm.$set(_vm.whiteIp, "ip", $$v);
      },
      expression: "whiteIp.ip"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.whiteIp.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.whiteIp, "phone", $$v);
      },
      expression: "whiteIp.phone"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "사유",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.whiteIp.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.whiteIp, "reason", $$v);
      },
      expression: "whiteIp.reason"
    }
  })], 1)], 1)], 1), _c('v-card-actions')], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("관리자 메모")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.whiteIp.note,
      callback: function callback($$v) {
        _vm.$set(_vm.whiteIp, "note", $$v);
      },
      expression: "whiteIp.note"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }